import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { useState } from 'react';

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: '#312F41',
  boxShadow: 24,
  p: 3,
  borderRadius: '30px',
};

interface IFollowModal {
  children: JSX.Element;
}

const SignInModal = ({ children }: IFollowModal) => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  //   const user0 = require('assets/Profile/buku_default_avatar.png');
  return (
    <div>
      <span onClick={handleOpen}>{children}</span>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{ ...style, width: { lg: '500px', xs: '300px' } }}>
          Please Sign In To Follow
        </Box>
      </Modal>
    </div>
  );
};

export default SignInModal;
